module.exports = "https://static.energy5.com/_next/static/images/fortressPower-f7dfef623d225910b09d31a5189bb183.png";